export class DateFormatConstant {
  static readonly DATE_FORMAT_V0: string = 'dd/MM/yyyy';
  static readonly DATE_FORMAT_V1: string = 'dd-MM-yyyy';
  static readonly DATE_FORMAT_V2: string = 'DD/MM/yyyy';
  static readonly DATE_FORMAT_V3: string = 'MM-dd-yyyy';
  static readonly DATE_FORMAT_V4: string = 'yyyy-MM-dd';
  static readonly DATE_FORMAT_V5: string = 'yyyy-MM-DD';
  static readonly DATE_FORMAT_V6: string = 'dd/MM/yyyy HH:mm:ss';
  static readonly DATE_FORMAT_V7: string = 'dd/MM/yyyy - HH:mm:ss';
  static readonly DATE_FORMAT_V8: string = 'yyyy-MM-ddTHH:mm:ss';
  static readonly DATE_FORMAT_V9: string = 'yyyy-MM-DD HH:mm:ss';
  static readonly DATE_FORMAT_V10: string = 'yyyy/MM/dd';
  static readonly DATE_FORMAT_V11: string = 'dd/mm/yy';
  
  static readonly HOUR_FORMAT_V0: string = 'HH:mm:ss';
  static readonly HOUR_FORMAT_V1: string = 'hh:mm:ss';
  static readonly HOUR_FORMAT_V2: string = 'hh:mm:ss a';
  static readonly HOUR_FORMAT_V3: string = 'hh:mm:ss aaaaa\'m\'';
}